import { render, staticRenderFns } from "./fccMetadado.vue?vue&type=template&id=6a7bc0f4"
import script from "./fccMetadado.vue?vue&type=script&lang=js"
export * from "./fccMetadado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports